import React, { useState, useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import { isArtworkWithError } from "./utils";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";
import "./DropZone.scss";

export default function DropZone({ ...restProps }) {
  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const [dropzoneVisible, setDropzoneVisible] = useState(false);
  const dropzoneRef = useRef(null);

  // Computed properties
  function artworks() {
    return store.artworks;
  }

  function showModal() {
    return store.showModal;
  }

  function isSpangle() {
    return store.isSpangle;
  }

  function isPuff() {
    return store.isPuff;
  }

  function isStickerSample() {
    return store.isStickerSample;
  }

  function spanglesMaxImageCount() {
    return spanglesStore.spanglesMaxImageCount;
  }

  /* TODO(vue-migration): artwork property not defined in Vue component; may be from store or parent */
  function artwork() {
    return store.artwork;
  }

  function metadata() {
    const { removeBackground, metadata: metadataValue, withBgMetadata } = artwork() || {};
    if (!withBgMetadata) {
      return metadataValue;
    }
    return removeBackground ? metadataValue : withBgMetadata;
  }

  function withErrors() {
    return metadata()?.errors?.length > 0 && !showModal();
  }

  /* TODO(vue-migration): replaceArtwork property not defined; may be from store */
  function replaceArtwork() {
    return store.replaceArtwork;
  }

  function addFilesToQueue(...args) {
    return store.addFilesToQueue(...args);
  }

  function removeArtworkByIndex(...args) {
    return store.removeArtworkByIndex(...args);
  }

  function setReplaceArtwork(...args) {
    return store.setReplaceArtwork(...args);
  }

  useEffect(() => {
    function handleDrop(e) {
      e.preventDefault();
      setDropzoneVisible(false);
      const { files } = e.dataTransfer;
      const userArtworks = artworks().filter(artworkItem => !artworkItem.isSimulated);
      let artworkIndex = null;
      if (
        files.length > 10 ||
        (isSpangle() && files.length > spanglesMaxImageCount()) ||
        ((isPuff() || isStickerSample()) && (userArtworks.length > 0 || files.length > 1))
      ) {
        return;
      }
      if (files.length <= 1 && replaceArtwork()) {
        artworkIndex = 0;
      } else {
        artworks().forEach((artworkItem, index) => {
          if (isArtworkWithError(artworkItem)) {
            removeArtworkByIndex(index);
          }
        });
      }
      addFilesToQueue({
        files,
        isDropEvent: true,
        artworkIndex
      });
      setReplaceArtwork(false);
    }

    function hideDropzone(e) {
      e.preventDefault();
      setDropzoneVisible(false);
    }

    function showDropzone(e) {
      e.preventDefault();
      setDropzoneVisible(true);
    }

    window.addEventListener("dragenter", showDropzone);
    window.addEventListener("dragover", showDropzone);
    window.addEventListener("drop", handleDrop);
    window.addEventListener("dragleave", hideDropzone);

    return () => {
      window.removeEventListener("dragenter", showDropzone);
      window.removeEventListener("dragover", showDropzone);
      window.removeEventListener("drop", handleDrop);
      window.removeEventListener("dragleave", hideDropzone);
    };
  }, []);

  return (
    <div
      {...restProps}
      className={cn("dropzone scope-b4d4a469", !dropzoneVisible && "hidden", restProps?.className)}
      ref={dropzoneRef}
    >
      <div className="dropzone__inner scope-b4d4a469">
        {" "}
        Drag and Drop <br className="scope-b4d4a469" /> Your Files Anywhere{" "}
      </div>
    </div>
  );
}
